module.exports = __webpack_public_path__ + "img/f1.2cdb94d4.jpg";